__turbopack_context__.v({
  "about-exp-links": "expRealtyFooterStyle-module-scss-module__E89Vpa__about-exp-links",
  "block": "expRealtyFooterStyle-module-scss-module__E89Vpa__block",
  "block1": "expRealtyFooterStyle-module-scss-module__E89Vpa__block1",
  "block2": "expRealtyFooterStyle-module-scss-module__E89Vpa__block2",
  "block3": "expRealtyFooterStyle-module-scss-module__E89Vpa__block3",
  "block4": "expRealtyFooterStyle-module-scss-module__E89Vpa__block4",
  "compact-brand-text": "expRealtyFooterStyle-module-scss-module__E89Vpa__compact-brand-text",
  "component": "expRealtyFooterStyle-module-scss-module__E89Vpa__component",
  "contact": "expRealtyFooterStyle-module-scss-module__E89Vpa__contact",
  "contact-item": "expRealtyFooterStyle-module-scss-module__E89Vpa__contact-item",
  "feature-flags": "expRealtyFooterStyle-module-scss-module__E89Vpa__feature-flags",
  "features": "expRealtyFooterStyle-module-scss-module__E89Vpa__features",
  "footer-big-text": "expRealtyFooterStyle-module-scss-module__E89Vpa__footer-big-text",
  "footer-bottom": "expRealtyFooterStyle-module-scss-module__E89Vpa__footer-bottom",
  "footer-links": "expRealtyFooterStyle-module-scss-module__E89Vpa__footer-links",
  "footer-top": "expRealtyFooterStyle-module-scss-module__E89Vpa__footer-top",
  "footer-top-left": "expRealtyFooterStyle-module-scss-module__E89Vpa__footer-top-left",
  "footer-top-right": "expRealtyFooterStyle-module-scss-module__E89Vpa__footer-top-right",
  "join-button": "expRealtyFooterStyle-module-scss-module__E89Vpa__join-button",
  "join-image-container": "expRealtyFooterStyle-module-scss-module__E89Vpa__join-image-container",
  "join-link": "expRealtyFooterStyle-module-scss-module__E89Vpa__join-link",
  "join-section": "expRealtyFooterStyle-module-scss-module__E89Vpa__join-section",
  "join-section-mobile-container": "expRealtyFooterStyle-module-scss-module__E89Vpa__join-section-mobile-container",
  "office-address": "expRealtyFooterStyle-module-scss-module__E89Vpa__office-address",
  "social-ig-icon": "expRealtyFooterStyle-module-scss-module__E89Vpa__social-ig-icon",
  "social-x-icon": "expRealtyFooterStyle-module-scss-module__E89Vpa__social-x-icon",
  "socials": "expRealtyFooterStyle-module-scss-module__E89Vpa__socials",
});
